import { ApplicationConfig, mergeApplicationConfig } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { commonConfig } from './app.config.common';
import { environment } from './environments/environment';
import { complex_links } from 'ctt-babylon';

export const appConfig: ApplicationConfig = mergeApplicationConfig(
    commonConfig,
    {
        providers: [
            provideClientHydration(),
            provideAnimations(),
            {
                provide: complex_links,
                useValue: environment.menuComplexLinks,
            },
        ],
    }
);
